import { IDLE, LOADING, SUCCESS, ERROR } from '../../../enums/states';
import { FETCH_PRESETS, FETCH_PRESETS_ERROR, FETCH_PRESETS_SUCCESS } from '../../actions/posPresets';
import { createReducer } from '../utils/reducer';

const initialState = {
  data: null,
  error: null,
  state: IDLE,
};

const handlers = {
  [FETCH_PRESETS]: (state) => {
    return {
      ...state,
      state: LOADING,
    };
  },
  [FETCH_PRESETS_SUCCESS]: (state, action) => {
    return {
      ...state,
      state: SUCCESS,
      data: action.payload,
    };
  },
  [FETCH_PRESETS_ERROR]: (state, action) => {
    return {
      ...state,
      state: ERROR,
      error: action.error,
    };
  },
};

export default createReducer(initialState, handlers);
